const DATATABLE_SELECTOR = '[datatable]'

const applyDataTables = (selector = null) => {
    if (!selector) {
        selector = DATATABLE_SELECTOR
    }
    document.querySelectorAll(selector).forEach(item => {
        
        if (item) {
            let table 
            const initDataTable = () => {
                // update wishlist and pantry list pricing
                item.querySelectorAll('input[name="quantity"]').forEach(inputElm => {
                    const pricelistElm = inputElm.closest('tr').querySelector('.product-price [data-fixed-price]')
                    if (pricelistElm) {
                        let catalogPrices = JSON.parse(pricelistElm.getAttribute('data-qb-prices'))
                        if (catalogPrices) {
                            catalogPrices = catalogPrices.sort((a, b) => b.minimumQuantity - a.minimumQuantity);
                            inputElm.addEventListener('change', function () {
                                let validPrice = catalogPrices.find(cP => +cP?.minimumQuantity <= +inputElm.value)

                                let displayPrice = +pricelistElm.getAttribute('data-fixed-price')
                                if (validPrice) {
                                    displayPrice = +validPrice?.price?.amount
                                }

                                if (document.querySelector('.t-selector-option-switch')) {
                                    displayPrice = computePriceWithTax(displayPrice)
                                    
                                    const isOn = !!document.querySelector('.t-selector-option-switch')?.checked
                                    const priceHelper = `(${isOn ? 'inc. GST' : 'ex. GST'})`
                                    const helperElm = pricelistElm.closest('tr').querySelector('.tax-price-helper')
                                    if (helperElm) {
                                        helperElm.textContent = priceHelper
                                    }
                                }
                                pricelistElm.textContent = displayPrice ? `$${displayPrice.toFixed(2)}` : '--'
                            })
                        }
                    }
                })

                
                item.querySelectorAll('.remove-from-wishlist').forEach(removeBtn => {
                    const itemDataset = removeBtn.dataset

                    removeBtn.addEventListener('click', function () {
                        // remove from list
                        const wishlistItem = removeBtn.closest('[wishlist-item]')
                        if (wishlistItem) {
                            const itemToRemove = wishlistItem.getAttribute('wishlist-item')
                            if (itemToRemove) {
                                document.querySelectorAll(`[wishlist-item="${itemToRemove}"]`).forEach(wishItem => {
                                    wishItem.remove()
                                })

                                if (document.querySelectorAll('[wishlist-item]').length === 0) {
                                    const wishlistTable = document.querySelector('.wishlist-page .dataTables_wrapper')
                                    if (wishlistTable) {
                                        wishlistTable.classList.add('hidden')
                                    }
                                    const wishlistNoData = document.querySelector('.wishlist-page .no-wishlist-data')
                                    if (wishlistNoData) {
                                        wishlistNoData.classList.remove('hidden')
                                    }

                                }
                            }
                        }

                        // remove from shopify
                        removeFromWishList(itemDataset);
                    })
                })


                table = $(item).DataTable({
                    fixedHeader: true,  // Enable sticky header
                    scrollX: true,  // Enable horizontal scrolling
                    autoWidth: false,  // Disable DataTables' automatic column width calculation
                    fixedColumns: {
                        leftColumns: 1,   // Fix the first column
                        rightColumns: $(window).width() > 767 ? 1 : 0   // Fix the last column
                    },
                    lengthMenu: [[20, 40, 60, 90], [20, 40, 60, 90]]
                })
            }

            initDataTable()
            // Redraw table on window resize to fix header alignment
            $(window).resize(function() {
                table.destroy();
                initDataTable();
            });
        }
    })
}

const accessToken  = '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'
const shopifyStore = "https://psupplies-com.myshopify.com"; // e.g., "psupplies-com"

getProductsByIDs = async (productIDList) => {
    if (!productIDList || !Array.isArray(productIDList) || productIDList.length === 0) {
        return [];
    }

    const res = await fetch(`${firebaseFunctions}/get-products-by-ids`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ productIDList })
    })
    const data = await res.json();
    return data || [];
}

async function getCompanyLocations(companyId) {
    if (!companyId) {
        return [];
    }

    const res = await fetch(`${firebaseFunctions}/get-company-locations`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ companyId })
    })
    const data = await res.json();
    return data || [];
}

async function fetchPriceLists(priceListIDs) {
    if (!priceListIDs || !Array.isArray(priceListIDs) || priceListIDs.length === 0) {
        return [];
    }
    
    const res = await fetch(`${firebaseFunctions}/fetch-price-lists`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ priceListIDs })
    })
    const data = await res.json();
    return data || [];
}

